import React from 'react'

export function SliderScale({ min, max, step, value, onChange, disabled }) {
  const current = value?.value ?? min
  return (
    <div style={styles.wrap}>
      <div style={styles.row}>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={current}
          onChange={(e) => !disabled && onChange({ value: Number(e.target.value) })}
          disabled={disabled}
          style={styles.slider}
          aria-label="Week rating"
        />
        <span style={styles.value}>{current}</span>
      </div>
      <div style={styles.ends}>
        <span>{min}</span>
        <span>{max}</span>
      </div>
    </div>
  )
}

const styles = {
  wrap: { padding: '12px 14px' },
  row: { display: 'flex', alignItems: 'center', gap: '10px' },
  slider: { flex: 1, accentColor: '#3b82c4', height: '6px', cursor: 'pointer' },
  value: { fontSize: '14px', fontWeight: 500, minWidth: '20px', textAlign: 'right', color: 'var(--text-primary)' },
  ends: { display: 'flex', justifyContent: 'space-between', fontSize: '10px', color: 'var(--text-secondary)', marginTop: '4px' },
}
